// extracted by mini-css-extract-plugin
export default {"unreadMessageContainer":"UnreadMessage_unreadMessageContainer__nReyy","title":"UnreadMessage_title__lX+bH","message":"UnreadMessage_message__UkR1k"};